import React, { useMemo } from "react";
//#region types
import { FormFieldProps, MonthRangeFormFieldProps } from "models/propTypes/genericFormProps";
import { UtilFormTypes } from "models/formTypes";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import MonthRangeSelector from "../../datePickers/monthRangeSelector";
//#endregion
import { DateHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function MonthRangePickerFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const {
    name,
    field,
    errors,
    touched,
    value,
    hideSuccess,
    handleOnChangeCustom,
    handleOnBlurCustom,
    invertedDisplayType,
    readonly,
  } = props;

  const extraProps = field.extraProps as MonthRangeFormFieldProps;

  const initialValue = useMemo(() => JSON.stringify(value), []);

  const dateRangeValue = value as UtilFormTypes.DateRange;

  const success = initialValue !== JSON.stringify(value) && !errors ? true : undefined;

  const startFieldName = `${name}.${FormFieldConstants.Util.DateRange.Start}`;
  const endFieldName = `${name}.${FormFieldConstants.Util.DateRange.End}`;

  return readonly ? (
    <ReadOnlyField label={field.label} href={field.href} className={cssExports.readOnlyTextField}>
      {dateRangeValue
        ? DateHelper.formatMonthRange(dateRangeValue.start ?? undefined, dateRangeValue.end ?? undefined)
        : ""}
    </ReadOnlyField>
  ) : (
    <MonthRangeSelector
      startDate={dateRangeValue?.start ?? undefined}
      endDate={dateRangeValue?.end ?? undefined}
      setStartDate={handleOnChangeCustom.bind(null, startFieldName)}
      setEndDate={handleOnChangeCustom.bind(null, endFieldName)}
      startDateError={
        touched &&
        touched[FormFieldConstants.Util.DateRange.Start] &&
        errors &&
        errors[FormFieldConstants.Util.DateRange.Start]
      }
      endDateError={
        touched &&
        touched[FormFieldConstants.Util.DateRange.End] &&
        errors &&
        errors[FormFieldConstants.Util.DateRange.End]
      }
      success={!hideSuccess && success}
      excludeMonths={extraProps?.excludeMonths}
      excludeRange={extraProps?.excludeRange}
      displayType={invertedDisplayType}
      onStartBlur={handleOnBlurCustom.bind(null, startFieldName)}
      onEndBlur={handleOnBlurCustom.bind(null, endFieldName)}
      onStartFocus={field.onFocusHandler}
      onEndFocus={field.onFocusHandler}
      className={field.classes?.input}
      hideClearable={extraProps?.hideClearable}
    />
  );
}

export default MonthRangePickerFormField;
